import Emitter from "./Emitter";

export default class DepositCompleted extends Emitter {
    constructor(gb) {
        super(gb);
    }

    IGT_handler() {
        this.emitGame(JSON.stringify({ message: "cust2rgsReloadGame" }));
    }

    _default() {
        this.emitGame({ wpgaction: "depositCompleted" });
    }
}